import { userConstants } from "../../constant";

export function ratedProduct(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_RATED_PRODUCT:
      return {
        product: action.product,
      };
    default:
      return state;
  }
}
